import React, { Component } from 'react';
import './style.css';
import { Route, Switch } from 'react-router-dom';
import Comparison from './comparison';
import Term from './term';
import Opposite from './opposite';
import Story from './story';
import Confirm from './confirm';

class Pair extends Component {
  constructor(props) {
    super(props);
    this.state = {
      term: props.pair.answer.term,
      opposite: props.pair.answer.opposite,
      story: props.pair.answer.story
    };
    this.handleChange = this.handleChange.bind(this);
    this.save = this.save.bind(this);
    this.saveTerm = this.saveTerm.bind(this);
    this.saveOpposite = this.saveOpposite.bind(this);
    this.saveStory = this.saveStory.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  save(singleAspect) {
    if (
      singleAspect.answer.term &&
      singleAspect.answer.opposite &&
      singleAspect.answer.story
    ) {
      this.props.save(singleAspect, this.props.pair.pairId);
    }
  }

  saveTerm(value) {
    this.setState({ term: value });
    let singleAspect = {
      answer: {
        term: value,
        opposite: this.state.opposite,
        story: this.state.story
      }
    };
    this.save(singleAspect);
  }

  saveOpposite(value) {
    this.setState({ opposite: value });
    let singleAspect = {
      answer: {
        term: this.state.term,
        opposite: value,
        story: this.state.story
      }
    };
    this.save(singleAspect);
  }

  saveStory(story) {
    this.setState({ story });
    let singleAspect = {
      answer: {
        term: this.state.term,
        opposite: this.state.opposite,
        story: story
      }
    };
    this.save(singleAspect);
  }

  render() {
    const props = this.props;
    const url = this.props.project + '/pair/' + this.props.pair.pairId;
    return (
      <Switch>
        <Route
          path={url}
          exact
          render={() => (
            <Comparison
              pair={props.pair}
              url={url}
              skip={props.skip}
              completionStatus={props.completionStatus}
            />
          )}
        />

        <Route
          path={url + '/confirm'}
          exact
          render={() => (
            <Confirm
              pair={props.pair}
              term={this.state.term}
              opposite={this.state.opposite}
              url={props.project}
              skip={props.skip}
              completionStatus={props.completionStatus}
            />
          )}
        />

        <Route
          path={url + '/story/similar'}
          exact
          render={() => (
            <Story
              completionStatus={props.completionStatus}
              pair={props.pair}
              save={this.saveStory}
              url={url}
              skip={props.skip}
              adjective="similar"
            />
          )}
        />

        <Route
          path={url + '/story/different'}
          exact
          render={() => (
            <Story
              completionStatus={props.completionStatus}
              pair={props.pair}
              save={this.saveStory}
              url={url}
              skip={props.skip}
              adjective="different"
            />
          )}
        />

        <Route
          path={url + '/opposite'}
          exact
          render={() => (
            <Opposite
              completionStatus={props.completionStatus}
              term={this.state.term}
              save={this.saveOpposite}
              url={url}
              skip={props.skip}
              pair={props.pair}
              maxLength="50"
            />
          )}
        />

        <Route
          path={url + '/similar'}
          exact
          render={() => (
            <Term
              completionStatus={props.completionStatus}
              story={this.state.story}
              pair={props.pair}
              save={this.saveTerm}
              saveStory={this.saveStory}
              url={url}
              skip={props.skip}
              adjective="similar"
              maxLength="50"
            />
          )}
        />

        <Route
          path={url + '/different'}
          exact
          render={() => (
            <Term
              completionStatus={props.completionStatus}
              story={this.state.story}
              pair={props.pair}
              save={this.saveTerm}
              saveStory={this.saveStory}
              url={url}
              skip={props.skip}
              adjective="different"
              maxLength="50"
            />
          )}
        />
      </Switch>
    );
  }
}

export default Pair;



// WEBPACK FOOTER //
// ./src/comparison-new/components/Pair/index.js